import worldJsonData from "./world.json";
const getDefaultCountry = () => {
  let Coords = [];
  /* istanbul ignore else */
  if (worldJsonData) {
    worldJsonData?.features?.map((worldjson) => {
      let shadedCountry = [];
      /* istanbul ignore else */
      if (shadedCountry && shadedCountry?.length < 1) {
        if (worldjson?.geometry && worldjson?.geometry?.type === "Polygon") {
          Coords?.push(
            worldjson?.geometry?.coordinates[0]?.map((item) => [
              item[1],
              item[0],
            ])
          );
        } else if (
          worldjson?.geometry &&
          worldjson?.geometry?.type === "MultiPolygon"
        ) {
          worldjson?.geometry?.coordinates?.map((cd) => {
            return Coords?.push(cd[0]?.map((item) => [item[1], item[0]]));
          });
        }
      }
      return worldjson;
    });
  }
  return Coords;
};
const mapFilterOptions = [
  "By Visitors",
  "By Orders",
  "By Revenue",
  "By Conversion Rate",
  "By deviation from forecast",
];
export { getDefaultCountry, mapFilterOptions };
